const eventHelpers = {

    throttle(fn, ms) {

        let throttling = false;

        return function _throttle() {
            if (!throttling) {

                throttling = true;
                setTimeout(() => {
                    throttling = false;
                    fn.apply(arguments);
                }, ms);

            }
        };

    },

    debounce(fn, ms) {

        let timeout;

        return function _debounce() {
            clearTimeout(timeout);
            timeout = setTimeout(() => fn.apply(null, arguments), ms);
        };

    },

    raf(fn) {

        let raf;

        return function _raf() {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => fn.apply(null, arguments));
        };

    }
};

export default eventHelpers;
